
import ReviewOptionTypeHelper from '@/mixins/ReviewOptionTypeHelper';

export default {
  name: 'AppFilterSectionReviewOptionTypeFilters',
  mixins: [ReviewOptionTypeHelper],
  props: {
    selectedReviewOptions: { type: Object, required: true }
  },
  data() {
    return {
      loadableReviewOptionTypes: true
    };
  }
};
